// React
import React from "react";
// Framework
import { forwardType, App } from "@mefisto/web";
// Loader
import { Loader } from "loader";
// Paths
import { paths as blogPaths } from "@plugins/blog";
import { paths as supportPaths } from "@plugins/support";

export default forwardType(App, () => (
  <App
    enabled
    name="PRESENTATION"
    type="NATIVE"
    title="Presentation"
    priority={0}
    loader={<Loader />}
    navigation={{
      basename: "/",
      routes: {
        default: "/",
        notAuthenticated: "/",
      },
      paths: {
        ...blogPaths,
        ...supportPaths,
        home: "/",
        faq: "/faq",
        features: "/features",
        pricing: "/pricing",
        terms: "/terms-of-service",
        privacy: "/privacy-policy",
        learnMoreParent: "/learn-more/parents",
        learnMoreSlp: "/learn-more/slps",
      },
    }}
    resource={{
      source: "ui",
    }}
  />
));
